import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@ontruck/ontruck-react-components/lib/Modal';
import Button from '@ontruck/ontruck-react-components/lib/Button';
import ButtonGroup from '@ontruck/ontruck-react-components/lib/ButtonGroup';
import Select from 'components/Select';

import style from './style.module.scss';

import { getSortedAreas } from 'redux/modules/areas/selectors';

const STATUSES = {
  open: 'open',
  close: 'close',
  mixed: 'mixed',
};

const MIXED_AREAS = 'MIXED_AREAS';

class OutcodesEditModal extends Component {
  constructor(props) {
    super(props);
    const { outcodes } = props;

    const status = _.every(outcodes, ['status', true])
      ? STATUSES.open
      : _.every(outcodes, ['status', false])
      ? STATUSES.close
      : STATUSES.mixed;

    const areas = outcodes.map(({ area }) => area);
    const onlyOneArea = _.uniq(areas).length === 1;
    const area = onlyOneArea ? areas[0] : MIXED_AREAS;

    this.state = {
      initialStatus: status,
      initialArea: area,
      status,
      area,
    };
    this.getModalTitle = this.getModalTitle.bind(this);
    this.handleSwitchStatus = this.handleSwitchStatus.bind(this);
    this.handleChangeArea = this.handleChangeArea.bind(this);
    this.handleSend = this.handleSend.bind(this);
  }

  getModalTitle() {
    const { outcodes, intl } = this.props;

    const t = intl.messages.components.OutcodesEditModal;

    if (!outcodes.length) {
      return '';
    }

    if (outcodes.length === 1) {
      return outcodes[0].outcode;
    }

    return (
      <FormattedMessage
        id="OutcodesEditModal.title"
        defaultMessage={t.title}
        values={{ total: outcodes.length }}
      />
    );
  }

  handleSwitchStatus(status) {
    this.setState({
      status,
    });
  }

  handleChangeArea(data) {
    this.setState({
      area: data && data.value,
    });
  }

  handleSend() {
    const { onSend } = this.props;

    const { area, status } = this.state;

    onSend({
      area,
      enabled: status === STATUSES.open,
    });
  }

  getStatuses() {
    const { intl } = this.props;

    const t = intl.messages.components.OutcodesEditModal;

    return [
      { text: t.open, value: STATUSES.open },
      { text: t.close, value: STATUSES.close },
    ];
  }

  render() {
    const { show, onClose, areas, outcodes, intl, editLoading } = this.props;

    const { status, area, initialStatus, initialArea } = this.state;

    const t = intl.messages.components.OutcodesEditModal;
    if (!outcodes.length) {
      return null;
    }

    const onlyNotAddedOutcodes = _.every(outcodes, ['not_added', true]);
    const wasMixedAreas = initialArea === MIXED_AREAS;
    const allowSave =
      (wasMixedAreas && initialArea !== area) ||
      (!wasMixedAreas && !onlyNotAddedOutcodes && initialStatus !== status) ||
      (!wasMixedAreas && initialArea !== area) ||
      (onlyNotAddedOutcodes && initialArea !== area);

    const options = areas && areas.length ? areas : [];

    if (editLoading)
      return (
        <Modal
          show
          size="S"
          onClose={() => {
            /*noop*/
          }}
          visibleOverflow
        >
          <ModalHeader>{t.editing_title}</ModalHeader>
          <ModalBody light visibleOverflow>
            {t.editing_body}
          </ModalBody>
        </Modal>
      );
    return (
      <Modal show={show} size="S" onClose={onClose} visibleOverflow>
        <ModalHeader>{this.getModalTitle()}</ModalHeader>
        <ModalBody light visibleOverflow>
          <ButtonGroup light active={status} onChange={this.handleSwitchStatus}>
            {this.getStatuses().map((status) => (
              <Button small key={status.value} value={status.value}>
                {status.text}
              </Button>
            ))}
          </ButtonGroup>

          {status === STATUSES.mixed && (
            <div className={style.mixedStatuses}>{t.mixed_statuses_advice}</div>
          )}

          {status !== initialStatus && outcodes.length > 1 && (
            <div className={style.openCloseAdvice}>
              {status === STATUSES.open ? (
                <FormattedMessage
                  id="OutcodesEditModal.action_advice_open"
                  defaultMessage={t.action_advice_open}
                  values={{ number: outcodes.length }}
                />
              ) : (
                <FormattedMessage
                  id="OutcodesEditModal.action_advice_close"
                  defaultMessage={t.action_advice_close}
                  values={{ number: outcodes.length }}
                />
              )}
            </div>
          )}

          {(initialArea === MIXED_AREAS || onlyNotAddedOutcodes) && (
            <div className={style.areaContainer}>
              <div>{t.add_to}</div>
              <div>
                <Select
                  placeholder={t.areas}
                  onChange={this.handleChangeArea}
                  options={options}
                  value={area}
                  clearable={false}
                />
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter light>
          <Button fullWidth onClick={this.handleSend} disabled={!allowSave}>
            {t.submit}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

OutcodesEditModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onSend: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  outcodes: PropTypes.array,
  areas: PropTypes.array,
  intl: PropTypes.object,
};

const mapStateToProps = (state) => ({
  areas: getSortedAreas(state),
});

export default injectIntl(connect(mapStateToProps)(OutcodesEditModal));
